import { BaseModel, PaginationDataModel, convertToArrayModels, convertToModel, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import type { PaginationData } from '~/shared/interfaces'
import ResearchDemandCard from './ResearchDemandCard'

export default class ResearchDemandQueryResult extends BaseModel {
  static override constructorName = 'ResearchDemandQueryResult'

  items: ResearchDemandCard[] = []
  pagination: PaginationData = new PaginationDataModel()

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    this.items = convertToArrayModels(data.data, ResearchDemandCard)

    this.pagination = convertToModel(data.meta, PaginationDataModel, this.pagination)
  }
}

registerModel(ResearchDemandQueryResult)
